 var iframe;
 var player;
 var loaded = false;

 //for difficult scroll
 var varTop, oldScrollValue = 0;


 function initEvents() {
     $(function() {
         $('#mc_embed_signup').addClass('ready');
         preloadAnimationControl();
         initArchiveMailchimpPopUp();
         setProducrDataLocation();
         classActiveForItemMenu();
         setActionForMenuEmptyLinks();
         changeImgToDivWithBg('.background', 'background');
         menuFix();
         initSearchForm();
         $('select').select2();
         //delete_cookie("MailchimpArchiveWasShowed");
         $("#mc_embed_signup > form").formchimp();


     });

     $(window).resize(function() {
         setProducrDataLocation();
         setBricks();
         verticalAlignForPopUp();
         setHeightForEmptyElement();
     });

     $(window).load(function() {

         loaded = true;
         setDifficultScroll('nav, .difficult-scroll');
         setHeightForEmptyElement();

         //autoplay for all video on desctop
         iframe = $('.template-index .post iframe');

         for (var i = 0; i < iframe.length; i++) {
             player = $f(iframe[i]);
             player.api('setVolume', 0);
             player.api('play');
         };

         setProducrDataLocation();
         setBricks();
         verticalAlignForPopUp();
     });
 }

 initEvents();


 //play half animation and ask to loaded page or not, if yes - fast end, else - slow end
 function preloadAnimationControl() {
     setTimeout(function() {
         if (loaded) {
             $('.loaded-logo').addClass('fast-loading');
             setTimeout(function() {
                 $('.loading-screen').hide();
             }, 800); // we use more time tnan animation duration because user shot sow - loading was end
         } else {
             $('.loaded-logo').addClass('slow-loading');
             setTimeout(function() {
                 $('.loading-screen').hide();
             }, 2300);
         }
     }, 2000); // 2s - time to work first part animation

 }



 //it script positions pproduct-data block, because on mobile it location another as on desctop
 function setProducrDataLocation() {

     var firstLi = $('.product-image-list li:first-child'); // it first image on list, data-product must stay after it

     if (getFullScreenWidth(getScrollBarWidth()) <= 991) {
         //if mobile we set position
         var margins = 60;
         var marginBottom = $('.product-data').height() + margins;
         var h = firstLi.height();
         firstLi.css('margin-bottom', marginBottom);
         $('.side-wrapper-right').attr('style', 'top: ' + (h + margins / 2) + 'px !important;');
     } else {
         //if desctop wi reset over styles (and will used style from css)
         $('.side-wrapper-right').attr('style', '');
         firstLi.attr('style', '');
     }
 }


 //supporting function determines the actual size of the screen
 function getFullScreenWidth(scrollbarWidth) {
     var widthWithoutScrollBar = $("body").width(),
         fullScreenWidth = widthWithoutScrollBar + scrollbarWidth;

     return fullScreenWidth;
 }

 function getScrollBarWidth() {
     var scrollbarWidth = function() {
         var a, b, c;
         if (c === undefined) {
             a = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body');
             b = a.children();
             c = b.innerWidth() - b.height(99).innerWidth();
             a.remove();
         }
         return c;
     };

     return scrollbarWidth();
 }


 //it change img element to div whith background. It best solution for stratching image (backfround size: cover)  for full screen on all devices.
 function changeImgToDivWithBg(imgSelector, divClass, doubleBg) {
     var tmpl, src, imgList = $(imgSelector);

     for (var i = 0; i < imgList.length; i++) {
         src = $(imgList[i]).attr('src');
         tmpl = '<div class="' + divClass + '" style="background-image:url(\'' + src + '\')"></div>';
         $(imgList[i]).parent().append(tmpl);
         if (doubleBg == true) {
             tmpl = '<div class="' + divClass + ' second-bg" style="background-image:url(\'' + src + '\')"></div>';
             $(imgList[i]).parent().append(tmpl);
         }
         $(imgList[i]).remove();
     }

 }

 function setBricks() {
     // we setup and run the plugin masonry
     if (getFullScreenWidth(getScrollBarWidth()) >= 767) {

         var width = $('.bricks-container').width() / 2;

         $('.shop-post-wrapper').width(width);
         $('.shop-post-wrapper:first-child, .shop-post-wrapper:last-child').width(width * 2);
         $('.bricks-container').masonry({
             itemSelector: '.shop-post-wrapper',
             columnWidth: width
         });
     } else {
         var width = $('.bricks-container').width();

         $('.shop-post-wrapper').width(width);
     }
 }

 function showSearchForm() {
     $('.search-form').addClass('search-active').addClass('visible');
     return false;
 }

 function hideSearchForm() {
     $('.search-form').removeClass('search-active');
     setTimeout(function() {
             $('.search-form').removeClass('visible');
         },
         1500);

     return false;
 }

 function initSearchForm() {
     $('#search').on('click', showSearchForm);
     $('.search-form > .close').on('click', hideSearchForm);
 }

 function classActiveForItemMenu() {
     //in main page in menu will opened first li
     if (window.location.pathname == "/") {
         $(".site-nav > li:first-child").addClass("site-nav--active");
     }
 }


 //add a class active to the parent
 function menuFix() {
     $(".site-nav--active").closest(".site-nav--has-dropdown").addClass('site-nav--active');
 }

 //its script for scroll navbar, and product-info block
 function setDifficultScroll(selector) {
     varTop = parseInt($(selector).parent().css('top'));

     $(window).scroll(function() {
         difficultScroll(selector);
     });
 }


 function difficultScroll(selector) {

     var currentScrollValue = parseInt($('body').scrollTop());
     var BOTTOM_MARGIN = 20;
     var objList = $(selector);
     var currentTop, objHeight;

     for (var i = 0; i < objList.length; i++) {

         obj = objList[i];
         currentTop = parseInt($(obj).css('top'));
         objHeight = parseInt($(obj).height());

         if (window.innerHeight > objHeight + varTop) {
             $(obj).css('top', 0);
             continue;
         }

         if (oldScrollValue <= currentScrollValue) {
             if (varTop < (objHeight - window.innerHeight + BOTTOM_MARGIN)) {
                 $(obj).css('top', (-currentScrollValue));
             }
             if (varTop >= (objHeight - window.innerHeight + BOTTOM_MARGIN)) {
                 $(obj).css('top', -(varTop + objHeight - window.innerHeight + BOTTOM_MARGIN));
             }
         } else {
             if (currentTop < 0) {
                 $(obj).css('top', (currentTop - (currentScrollValue - oldScrollValue)));
             }
             currentTop = parseInt($(obj).css('top'));
             if (currentTop >= 0) {
                 $(obj).css('top', 0);
             }
         }
     }
     oldScrollValue = currentScrollValue;

 }

 function setActionForMenuEmptyLinks() {
     // (on desctop) if link have not children we can not open it, because wi need it function
     $('.nav-bar a[href="#"]').on('click', function() {
         $('.site-nav--active').removeClass('site-nav--active');
         $(this).parent().addClass('site-nav--active');
     });
 }



 //ned only for testing
 function delete_cookie(cookie_name) {
     var cookie_date = new Date(); // Текущая дата и время
     cookie_date.setTime(cookie_date.getTime() - 1);
     document.cookie = cookie_name += "=; expires=" + cookie_date.toGMTString();
 }


 //cheking to show or not to show popup  
 function checkCookies() {
     if ($('#mc_embed_signup.mainPopUp').length > 0) {
         if (get_cookie("MailchimpWasShowed")) {
             $('#mc_embed_signup.mainPopUp').hide();
         } else {
             checkMailchimpPopUp();
         }
     }

     if ($('#mc_embed_signup.archivePopUp').length > 0) {
         if (get_cookie("MailchimpArchiveWasShowed")) {
             $('#mc_embed_signup.archivePopUp').hide();
         }
     }

 }

 function initArchiveMailchimpPopUp() {
     checkCookies();
     $('#mc_embed_signup.archivePopUp .close').on('click', function() {
         $('#mc_embed_signup').hide();
         return false;
     });

     $('#mc_embed_signup.mainPopUp .close').css('display', 'block').on('click', function() {
         $('#mc_embed_signup').hide();
         return false;
     });
 }

 function verticalAlignForPopUp() {
     var marginTop = ($('#mc_embed_signup').outerHeight() - $('#mc_embed_signup form').outerHeight()) / 2;
     $('#mc_embed_signup form').css('position', 'relative').css('margin-top', marginTop).css('top', '0');
 }


 function get_cookie(cookie_name) {
     var results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');

     if (results)
         return (unescape(results[2]));
     else
         return null;
 }


 //for submit
 function checkMailchimpPopUp() {
     var now = new Date();

     //coockie will work onli 15 minutes
     var endExist = new Date(now.getTime() + 1000 * 3600 * 24 * 15); // 15 days  (15 days = 1000*3600*24*15)
     endExist = endExist.toGMTString()
     document.cookie = "MailchimpWasShowed=true; expires=" + endExist + ";";
 }


 function checkMailchimpArchivePopUp() {
     var now = new Date();

     //coockie will work onli 15 minutes
     var endExist = new Date(now.getTime() + 1000 * 3600 * 24 * 15); // 15 days  (15 days = 1000*3600*24*15)
     endExist = endExist.toGMTString()
     document.cookie = "MailchimpArchiveWasShowed=true; expires=" + endExist + ";";
 }

 function setHeightForEmptyElement() {
     var products = $(".main-container .product-item"),
         length = products.length,
         currentElementHeight, maxHeight = 0;

     if (products.length > 0) {
         for (var i = 0; i < length; i++) {
             currentElementHeight = $(products[i]).find('a img').height();
             if (maxHeight < currentElementHeight) {
                 maxHeight = currentElementHeight;
             }
         }

         for (var i = 0; i < length; i++) {
             if ($(products[i]).find('a img').length == 0) {
                 if ($(products[i]).find('.no_img').length > 0) {
                     $(products[i]).find('.no_img').css('height', maxHeight);
                 } else {
                     var tmp = "<a class='no_img' href='" + $(products[i]).find('a').attr('href') + "' style='height:" + maxHeight + "px'></a>";
                     $(products[i]).prepend(tmp);
                 }
             }
         }
     }
 }